import {css} from 'lit';

/*
This file is reserved for any custom css that developers want to add to
customize their theme. Simply add your css to this file and yarn build.
*/

export default css`

	:host {
		min-width: 0px;
		--primary-color: var(--bright-pink);
		--light-fg: var(--text-color);
		--green: #16666A;
		--orange: #2CCCD2;
		--blue: #470A69;
		--yellow: #D20259;
		--red: #D20259;
		--fg: #2D2926;
		--fg2: #2D2926;
		--fg3: #2D2926;
	}

	.body {
		gap: 20px;
		flex-flow: column;

		@media (min-width: 760px) {
			gap: 30px;
		}

		@media (min-width: 1024px) {
			flex-flow: row;
			gap: 40px;
		}

		@media (min-width: 1600px) {
			gap: 60px;
		}
	}

	.nav-bar {
		width: 100%;

		@media (min-width: 1024px) {
			width: 270px;
		}

		@media (min-width: 1600px) {
			width: 300px;
		}
	}

	.section-gap--focused-mode,
	.section-gap--read-mode {
		padding: 0;
	}

	.nav-search-container {
		display: flex;
		align-items: center;
	}

	.nav-search-container-input {
		width: 100%;
		position: relative;
	}

	.nav-search-container-input .icon {
		position: absolute;
		top: 6px;
		right: 4px;
		color: #5e5e5e;
		font-size: 18px;
	}

	.nav-search-container input {
		border-radius: 5px 0 0 5px;
		width: 100%;
		height: 38px;
		font-size: 16px;
		line-height: 15px;
		font-family: GTEestiProDisplay, Arial, sans-serif;
		border-right: none;
		padding: 10px 30px 10px 12px;
	}

	.nav-search-container input:focus {
		border-color: var(--bright-pink) !important;
	}

	.nav-search-container .m-btn {
		background: var(--bright-pink);
		border: none;

		font-size: 14px;
		line-height: 15px;
		font-weight: 400;
		border-radius: 0 5px 5px 0;
		height: 38px;

		text-transform: capitalize;
		margin: 0 !important;

		width: auto !important;
		padding: 4px 8px !important;

		@media (min-width: 760px) {
			padding: 8px 10px !important;
			font-size: 16px;
			line-height: 15px;
			width: 100px !important;
		}

		@media (min-width: 1600px) {
			padding: 7px 15px !important;
		}
	}

	.nav-scroll {
		overflow: visible;
	}

	.nav-bar, .nav-scroll {
		background: none;
		display: flex;
		flex-flow: column;
		gap: 15px;
	}

	.nav-bar .nav-bar-item {
		color: #000;
	}

	.nav-bar-tag {
		background: none;
		color: var(--text-color);

		font-size: 16px;
		line-height: 22px;
		padding: 5px;
		text-decoration: none;
		font-weight: 400;
		margin: 0;
		border-radius: 0;
		border: none;

		@media (min-width: 47.5rem) {
			font-size: 18px;
			line-height: 28px;
		}

		@media (min-width: 100rem) {
			font-size: 22px;
			line-height: 28px;
		}
	}

	.nav-bar-tag:hover {
		background: none;
		color: var(--text-color);
	}

	.nav-bar-tag-icon {
		color: inherit;
		width: 16px;
		height: 16px;
		flex: 0 0 auto;
		font-size: 0;
	}

	.nav-bar-tag-icon::after {
		content: '' !important;
		width: 16px !important;
		height: 16px !important;
		background: url(/wp-content/themes/bango-developer-theme/images/svg/arrow--CE0058.svg) no-repeat center center / contain;
		transform-origin: center;
		transform: rotate(-90deg);
	}

	.nav-bar.focused .nav-bar-tag-and-paths.collapsed .nav-bar-tag-icon::after {
		transform: rotate(90deg);
	}

	.nav-bar-path.left-bar {
		background: none;
		border: none !important;

		font-size: 16px;
		line-height: 22px;
		display: flex;
		flex-flow: row;
		align-items: flex-start;
		justify-content: flex-start;
		column-gap: 10px;
		color: var(--text-color);
		font-weight: 300;
		text-decoration: none;

		@media (min-width: 80rem) {
			padding: 12px 24px;
		}

		@media (min-width: 100rem) {
			font-size: 18px;
			line-height: 24px;
		}
	}

	.nav-bar-path.left-bar:hover {
		color: var(--bright-pink);
		text-decoration: underline;
		background-color: #f9f9f9;
	}

	.nav-bar-path.left-bar::before {
		content: '';
		display: inline-block;
		width: 7px;
		height: 14px;
		background: url(/wp-content/themes/bango-developer-theme/images/svg/arrow--CE0058.svg) no-repeat center center / contain;
		transform: translateY(4px);
		flex: 0 0 auto;
	}

	.nav-bar-path.left-bar.active {
		color: var(--bright-pink);
	}

	.body, .main-content {
		height: fit-content !important;
	}

	.expanded-endpoint-body {
		padding: 0;
	}

	.tag-container {
		border-bottom: 1px solid #e0e0e0;
	}

	.main-content {
		padding: 2px;
	}

	.tag-description {
		border: none;
		margin-top: 20px;
		font-weight: 300;
		background: #fafafab3;
	}

	.tag-description .m-markdown {
		padding: 10px 15px 8px;
	}

	.m-markdown {
		display: flex;
		flex-flow: column;
	}

	.m-markdown p {
		margin: 0;
	}

	.section-title {
		color: var(--text-color);
		font-weight: 500;
		font-size: 22px;
		line-height: 28px;
		text-transform: capitalize;
		display: inline-flex;
		gap: 10px;
		align-items: center;

		@media (min-width: 760px) {
			font-size: 26px;
			line-height: 30px;
		}

		@media (min-width: 1280px) {
			font-size: 28px;
			line-height: 32px;
		}

		@media (min-width: 1600px) {
			font-size: 30px;
			line-height: 36px;
		}
	}

	.section-title span {
		display: block;
	}

	h2 {
		color: var(--heading-color);
		font-size: 18px;
		line-height: 22px;
		font-weight: 400;

		@media (min-width: 760px) {
			font-size: 22px;
			line-height: 24px;
		}

		@media (min-width: 1280px) {
			font-size: 24px;
			line-height: 26px;
		}

		@media (min-width: 1600px) {
			font-size: 26px;
			line-height: 30px;
		}
	}

	.operation-method {
		display: flex;
		margin: 15px 0;
	}

	.operation-method-method {
		background: #ededed;
		padding: 12px 15px 9px;
	}

	.operation-method-path {
		padding: 11px 15px 10px;
		background: #fafafa;
		width: 100%;
	}

	.m-markdown p:not(:first-child) {
		margin: 0;
	}

	.m-markdown p {
		font-weight: 300;
		color: var(--text-color);
		font-size: 16px;
		line-height: 22px;

		@media (min-width: 1600px) {
			font-size: 18px;
			line-height: 24px;
		}
	}

	.m-markdown-medium p {
		font-weight: 300;
		color: var(--text-color);
		font-size: 14px;
		line-height: 20px;

		@media (min-width: 1600px) {
			font-size: 16px;
			line-height: 22px;
		}
	}

	.req-res-title {
		color: var(--text-color);
		font-size: 16px;
		line-height: 22px;
		font-weight: 500;
		text-transform: capitalize;
		padding-bottom: 10px;
		border-bottom: 1px solid #e0e0e0;
		margin-bottom: 15px;

		@media (min-width: 1280px) {
			font-size: 20px;
			line-height: 26px;
		}

		@media (min-width: 1600px) {
			font-size: 22px;
			line-height: 28px;
		}
	}

	.m-btn {
		border-radius: 5px;
		font-weight: 500;

		font-size: 14px;
		line-height: 15px;

		padding: 7px 15px 6px;
		box-shadow: none;

		@media (min-width: 760px) {
			font-size: 16px;
			line-height: 15px;
		}
	}

	.m-btn.small {
		font-size: 14px;
		line-height: 15px;
		padding: 5px 11px 4px;
	}

	.toolbar-btn {
		border-radius: 5px;
		padding: 5px 11px;
	}

	.table-title {
		color: var(--text-color);

		font-size: 18px;
		line-height: 24px;
		font-weight: 500;

		@media (min-width: 1280px) {
			font-size: 20px;
			line-height: 26px;
		}
	}

	.table-title-small {
		font-size: 0.8rem;
		font-weight: 300;
		color: var(--heading-color);
	}

	dialog-box {
		z-index: 1000000;
	}

	.tab-panel {
		margin-top: 20px;
	}

	.tab-buttons {
		padding: 0;
	}

	.tab-btn {
		font-size: 14px;
		line-height: 15px;
		padding: 5px 11px 4px;
	}

	.tab-content {
		gap: 10px;
	}

	.advanced-search-options .search-input {
		border-radius: 5px 0 0 5px;
		width: 100%;
		height: 38px;
		font-size: 16px;
		line-height: 15px;
		font-family: GTEestiProDisplay, Arial, sans-serif;
		border-right: none;
		padding: 10px 30px 10px 12px;
	}

	input[type="checkbox"]:checked {
		background-color: var(--bright-pink);
		border-color: var(--bright-pink);
	}

	input[type="checkbox"]:checked:after {
		border-color: var(--bright-pink);
	}

	.checkbox-container {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 7px;
	}

	.additional-information {
		display: flex;
	}

	.additional-information-title {
		background: #ededed;
		padding: 6px 10px;
		text-transform: uppercase;
		font-weight: 500;
	}

	.additional-information-text {
		background: #fafafa;
		padding: 6px 15px;
		word-break: break-all;
	}


	.focused-mode {
		border-top: none;
		padding-top: 0;
	}

	.tab-content > .border-top:first-child {
		border-top: none;
	}

	.m-table tr[title] td, .m-table tr[title] th {
		padding: 10px 5px 5px;
		vertical-align: middle;
	}

	.m-table tr:not([title]) td, .m-table tr:not([title]) th {
		padding: 5px 5px 10px;
		vertical-align: middle;
	}

	input.request-param {
		border-radius: 5px;
		width: 100%;
		height: 38px;
		font-size: 16px;
		line-height: 15px;
		font-family: GTEestiProDisplay, Arial, sans-serif;
		padding: 10px 12px;
	}

	.response-message {
		font-size: 14px;
		line-height: 22px;
		font-weight: 400;
	}

	.side-by-side {
		display: flex;
		flex-flow: column;
		gap: 30px;
		padding-top: 20px;

		@media (min-width: 1366px) {
			flex-flow: row;
			gap: 20px;
		}
	}

	.side-by-side::before {
		content: '';
		width: 0;
		border-left: 1px dashed #e0e0e0;
		flex: 1 1 auto;
		order: 2;
		display: none;
	}

	@media (min-width: 1366px) {
		.side-by-side::before {
			display: block;
		}
	}

	.side-by-side api-request,
	.side-by-side api-response {
		width: 50%;
		flex: 1 1 auto;
		order: 3;
	}

	.side-by-side api-request {
		order: 1;
	}

	.focused-mode,
	.read-mode {
		padding: 0;
		margin: 0;
	}

	.collapsed-all-descr .tr:not(.expanded-descr) {
		max-height: none;
	}

	.collapsable-content {
		display: grid;
		grid-template-rows: 0fr;
		transition: all 200ms ease-in-out;
	}

	.collapsable-content__content {
		overflow: hidden;
	}

	.expanded-descr .collapsable-content {
		grid-template-rows: 1fr;
	}

	.miss {
		display: block;
	}

	input:focus,
	.m-btn:focus,
	.tab-btn:focus {
		outline: 2px solid #ce005885;
	}

	:host,
	.body,
	.nav-bar,
	.tab-buttons {
		overflow: visible;
	}

	.tooltip:focus-within {
		outline: 2px solid #ce005885;
	}

	.tooltip:focus-within a {
		outline: none;
	}

	.m-table tr.tr-title-row td {
		padding: 10px 10px 8px;
	}

	.m-table tr.tr-title-row td .param-name,
	.m-table tr.tr-title-row td .param-type {
		text-align: left;
	}

	.m-table tr.tr-input-row td {
		padding: 0 10px;
		border: none;
		overflow: visible;
	}

	.m-table tr.tr-constraint-row td {
		padding: 10px 10px 0;
		border: none;
	}

	.m-table tr.tr-info-row td {
		padding: 10px;
	}

	td .m-markdown-small ul {
		margin: 0;
	}

	.nav-bar-info.left-bar {
		background: none;
		color: var(--text-color);

		font-size: 16px;
		line-height: 22px;
		padding: 5px;
		text-decoration: none;
		font-weight: 400;
		margin: 0;
		border-radius: 0;
		border: none;

		@media (min-width: 47.5rem) {
			font-size: 18px;
			line-height: 28px;
		}

		@media (min-width: 100rem) {
			font-size: 22px;
			line-height: 28px;
		}
	}

	.nav-bar-info.left-bar.active {
		border: none;
		color: var(--primary-color);
	}

	.nav-bar-info.left-bar:focus-visible {
		outline: 1px solid;
		box-shadow: none;
		outline-offset: -4px;
	}

	.nav-bar-info.left-bar:hover:not(.active) {
		background: none;
		color: var(--text-color);
	}

	#link-operations-top {
		display: none !important;
	}

	.auth-inputs {
		width: 100%;
		display: flex;
		flex-flow: column;
		gap: 10px;
		max-width: 700px;
		margin-top: 20px;

		@media (min-width: 47.5rem) {
			flex-flow: row;
		}
	}

	.auth-inputs input {
		width: 100%;
		border-radius: 5px;
		height: 38px;
		font-size: 16px;
		line-height: 15px;
		font-family: GTEestiProDisplay, Arial, sans-serif;
		padding: 10px 12px;
	}

	.auth-inputs-input {
		display: flex;
		flex-flow: column;
		gap: 5px;
		width: 100%;

		@media (min-width: 47.5rem) {
			width: 50%;
		}
	}

	.auth-inputs-input label {
		font-size: 16px;
		font-weight: 500;
	}

	.auth-inputs .m-btn {
		width: 100%;
		text-align: center;
		height: 38px;

		@media (min-width: 47.5rem) {
			width: auto;
			flex: 0 0 auto;
			margin-top: auto;
		}
	}

	.m-table.auth {
		margin-top: 15px;
	}

	.m-table.auth tr td {
		padding: 15px;
	}
`;
